import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { useDarkMode } from '../context/DarkModeContext';
import ContactSection from '../components/ContactSection';

const META_TITLE = 'Kontakt – BAFA-Bericht-Generator | StartKlar.Digital';
const META_DESCRIPTION =
  'Fragen zum BAFA-Bericht-Generator, zu Preisen oder zur BAFA-Zulassung? Schreib uns direkt über das Kontaktformular oder per E-Mail und Telefon.';

const SUBJECTS = ['Allgemeine Anfrage', 'Vertrieb / Preise', 'Technischer Support', 'BAFA-Zulassung / Beratung', 'Presse / Partner'];

export default function Kontakt() {
  const { darkMode } = useDarkMode();
  const [searchParams] = useSearchParams();

  const subjectParam = searchParams.get('subject') ?? undefined;
  const messageParam = searchParams.get('message') ?? undefined;
  const initialSubject = subjectParam && SUBJECTS.includes(subjectParam) ? subjectParam : undefined;

  useEffect(() => {
    const previousTitle = document.title;
    document.title = META_TITLE;
    let descTag = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    const hadDescTag = !!descTag;
    const previousDesc = descTag?.content ?? '';
    if (!descTag) {
      descTag = document.createElement('meta');
      descTag.name = 'description';
      document.head.appendChild(descTag);
    }
    descTag.content = META_DESCRIPTION;
    return () => {
      document.title = previousTitle;
      if (hadDescTag && descTag) descTag.content = previousDesc;
      else if (descTag) descTag.remove();
    };
  }, []);

  const pageBg = darkMode ? 'bg-slate-900 text-slate-200' : 'bg-white text-slate-700';
  const headingColor = darkMode ? 'text-white' : 'text-slate-900';
  const mutedText = darkMode ? 'text-slate-400' : 'text-slate-500';

  return (
    <div className={`min-h-screen ${pageBg}`}>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <header className="text-center mb-10">
          <h1 className={`text-3xl md:text-5xl font-bold mb-4 leading-tight ${headingColor}`}>Kontakt</h1>
          <p className={`text-base md:text-lg max-w-2xl mx-auto ${mutedText}`}>
            Schreiben Sie uns eine Nachricht oder erreichen Sie uns direkt per E-Mail und Telefon. Wir melden uns in der Regel innerhalb eines Werktages.
          </p>
        </header>
        <ContactSection initialSubject={initialSubject} initialMessage={messageParam} headingLevel={2} />
      </div>
    </div>
  );
}
